import { Component, Input } from '@angular/core';
import { ClientPrescriberTask } from '../../../core/models/client-prescriber-task.model';
import { CeReviewTaskContentComponent } from '../ce-review-task-content/ce-review-task-content.component';
import { DatePipe } from '@angular/common';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';

@Component({
    selector: 'app-ce-review-client-prescriber-task',
    templateUrl: './ce-review-client-prescriber-task.component.html',
    imports: [CeReviewTaskContentComponent, DatePipe, BlankValueDashPipe]
})
export class CeReviewClientPrescriberTaskComponent {
  @Input() clientPrescriberTask: ClientPrescriberTask;
}
